export default class CustomerReviews {
  DEBUG = false;
  API_URL = "https://cl.avis-verifies.com/fr/cache/d/c/c/dcc5ca4e-68df-c414-bd7f-53ef20145ddc/AWS/PRODUCT_API";
  PRODUCT_ID = undefined;
  AVERAGE = {
    note: 0,
    total: 0
  };
  REVIEWS = [];
  REVIEWS_COUNT = {
    1: {
      count: 0,
      percent: 0
    },
    2: {
      count: 0,
      percent: 0
    },
    3: {
      count: 0,
      percent: 0
    },
    4: {
      count: 0,
      percent: 0
    },
    5: {
      count: 0,
      percent: 0
    }
  };
  constructor(product_ids, callback) {
    this.PRODUCT_IDS = product_ids;
    this.DEBUG ? console.log("PRODUCT IDS", this.PRODUCT_IDS) : null;
  }
  init(callback) {
    let productIdsArray = this.PRODUCT_IDS.split(',');

    // On catch les erreur à chaque récupération pour que le promise.all ne s'arrête pas
    let promises = productIdsArray.map(id => this.getProductReview(id).catch(err => {
      console.error(err);
      return []; // return a default value when an error occurs
    }));
    Promise.all(promises).then(reviewsArray => {
      // On récupère les avis de chaque produit et on les ajoute à notre liste de reviews
      reviewsArray.forEach(reviews => {
        this.REVIEWS.push(...reviews);
      });
      this.DEBUG ? console.log("REVIEWS", this.REVIEWS) : null;
      if (this.REVIEWS.length === 0) {
        this.removeReviews("No reviews found");
        return;
      }

      // Nous n'avons pas accès à l'API pour récupérer les notes moyennes
      // On calcule donc le total de notes et la moyenne grâce à la liste des avis
      this.AVERAGE.total = this.REVIEWS.length;
      let averageNote = this.REVIEWS.reduce((acc, review) => acc + parseInt(review.rate), 0) / this.AVERAGE.total;
      this.AVERAGE.note = Math.round(averageNote * 10) / 10;
      this.DEBUG ? console.log("AVERAGE", this.AVERAGE) : null;

      //On compte le nombre de review pour chaque note
      this.REVIEWS.forEach(review => {
        this.REVIEWS_COUNT[review.rate].count = this.REVIEWS_COUNT[review.rate].count + 1;
      });

      //On calcule le pourcentage représenté par chacune des notes par rapport au nombre total des notes.
      //Utilisé pour calculer la longueur des barres dans le header du module
      Object.keys(this.REVIEWS_COUNT).forEach(rate => {
        this.REVIEWS_COUNT[rate].percent = this.REVIEWS_COUNT[rate].count / this.AVERAGE.total * 100;
      });
      this.DEBUG ? console.log("REVIEWS COUNT", this.REVIEWS_COUNT) : null;
      if (callback) {
        callback();
      }
    });
  }
  getProductReview(product_id) {
    console.log('get product review');
    return fetch(`${this.API_URL}/REVIEWS/${product_id}.json`).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Error while fetching reviews");
      }
    }).catch(err => {
      throw new Error(err);
    });
  }
  removeReviews(err) {
    console.log('remove reviews');
    this.DEBUG ? console.error(err) : "";
    this.AVERAGE = undefined;
    this.REVIEWS = undefined;
    if (document.querySelector('#customers-reviews')) {
      document.querySelector('#customers-reviews').remove();
    }
  }
  generateHtml() {
    if (this.REVIEWS !== undefined) {
      this.injectProductAverage();
      this.injectComment();
      this.injectMetaDatas();
    }
  }
  injectProductAverage() {
    console.log('inject product average');
    document.querySelector('.cr-product__rate-average-text-note').innerText = this.AVERAGE?.note;
    document.querySelector('.cr-product__rate-average-text-count').innerText = this.AVERAGE?.total;
    //On multiplie la note par 20 pour passer d'une note sur 5 à une note sur 100.
    document.querySelector(`.cr-product__rate-average-stars-icons-active`).style.width = this.AVERAGE?.note * 20 + "%";
    document.querySelector('.cr-product__rate-average').classList.add('is-visible');
  }
  injectComment() {
    console.log('inject comments');
    if (document.querySelector('.no-reviews-text') !== null) {
      document.querySelector('.no-reviews-text').style.display = "none";
    }
    const review_template = window.customerReviewsTemplate.review;
    let reviews_html = "";
    this.REVIEWS.forEach((review, index) => {
      //On créer un élément HTML que l'on va pouvoir manipuler pour créer le html de notre review
      let html = document.createElement("template");
      html.innerHTML = review_template;

      //On injecte toutes les variables dans notre template.

      let ordered_at = new Date(review.order_date);
      html.content.querySelector('.cr-review__author-name').innerHTML = review.firstname !== "anonymous" ? review.firstname : window.i18n.productReviews.anonymous;
      html.content.querySelector('.cr-review__content-ordered-at span').innerHTML = ('0' + ordered_at.getDate()).slice(-2) + "/" + ('0' + (ordered_at.getMonth() + 1)).slice(-2) + "/" + ordered_at.getFullYear();
      html.content.querySelector('.cr-review__content-text p').innerHTML = review.review;
      let stars = html.content.querySelectorAll('.cr-review__rate > .cr-review__rate-star');
      for (let i = 0; i < review.rate; i++) {
        stars[i].classList.add('active');
      }

      //On rend les réponses au reviews et on les intègres dans le html
      review?.moderation?.forEach(comment => {
        let response_html = document.createElement("template");
        response_html.innerHTML = window.customerReviewsTemplate.response;
        response_html.content.querySelector('.cr-response__text').innerHTML = comment.comment;
        html.content.querySelector('.cr-review__content-text-reply').innerHTML += response_html.innerHTML;
      });
      reviews_html += html.innerHTML;
    });
    document.querySelector(".cr-contents").innerHTML = reviews_html;
  }
  injectMetaDatas() {
    console.log('inject meta datas');
    let json = JSON.parse(document.querySelector('script#main-microdata').innerText);
    let bestRating = 0;
    let worstRating = 5;
    Object.keys(this.REVIEWS_COUNT).forEach(rate => {
      if (this.REVIEWS_COUNT[rate].count > 0) {
        if (parseInt(rate) > bestRating) {
          bestRating = parseInt(rate);
        }
        if (parseInt(rate) < worstRating) {
          worstRating = parseInt(rate);
        }
      }
    });
    json.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": parseFloat(this.AVERAGE?.note).toFixed(2),
      "ratingCount": parseInt(this.AVERAGE?.total),
      "bestRating": bestRating,
      "worstRating": worstRating
    };

    // Update json
    document.querySelector('script#main-microdata').innerText = JSON.stringify(json);
  }
}